import {UseInfiniteQueryResult, useInfiniteQuery} from '@tanstack/react-query';

import api from 'app/modules/Remote/api';

import {FeatureMetadataApiResponse} from '../types';

const PER_PAGE = 100;

export function useOrgFeatureMetadata(
  orgId: string,
  metadataFields?: string[]
): UseInfiniteQueryResult<FeatureMetadataApiResponse[], Error> {
  return useInfiniteQuery({
    queryKey: ['featureMetadata', orgId, metadataFields],
    queryFn: async ({pageParam = 1}) => {
      const response = await api.dashboardStats(orgId).getFeatures({
        page: pageParam,
        perPage: PER_PAGE,
        metadataField: metadataFields,
      });

      const data = response.get('data').toJS();
      return data;
    },
    getNextPageParam: (lastPage, allPages) => {
      // If the last page has less items than page size, we've reached the end
      const hasMore = lastPage.length === PER_PAGE;
      return hasMore ? allPages.length + 1 : undefined;
    },
    initialPageParam: 1,
    // by default, react-query considers data stale immediately, so if our cache is invalidated
    // for any reason, it will refetch. this query is costly to refetch esp for big orgs, so im
    // pulling an hf-web and setting the cache to never stale. users will be able to refresh the
    // page if they want to get the latest data during their session.
    // maybe we will set a diff default for notes/reports.
    staleTime: Infinity,
    select: (data) => {
      return data.pages.flat();
    },
  });
}
